module.exports = __webpack_public_path__ + "img/rectangle_bold_transparent_rounded.e475ba90.svg";